export default {"src":"/_next/static/media/expand-more.02e2632b.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};